export default {
  setLocale({ commit }, payload) {
    commit('setLocale', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js